import { Link } from 'react-router-dom'
import PostMioLogo from '../components/PostMioLogo'

// Note: This page is not linked in the main nav.
// It exists as a standalone URL /pricing for future use.

// ── i18n ───────────────────────────────────────────────────
const UI_TEXT = {
  IT: {
    about: 'Chi siamo',
    reviews: 'Recensioni',
    login: 'Accedi',
    tag: 'Prezzi',
    h1: 'Un prezzo. Nessuna sorpresa.',
    sub: 'Meno di un caffè al giorno per non pensarci più.',
    period: '/mese',
    trial: '7 giorni gratis · Poi €9,99/mese · Disdici quando vuoi',
    features: [
      'Post illimitati per Instagram, Facebook, WhatsApp',
      'Risposte alle recensioni Google',
      '3 toni: caldo, professionale, vivace',
      'Copia in un click',
      'Accesso immediato',
    ],
    cta: 'Inizia gratis per 7 giorni →',
    trust: ['🔒 Pagamento sicuro', '✓ Disdici quando vuoi', '✓ 0€ per 7 giorni'],
    hasAccount: 'Hai già un account?',
    loginLink: 'Accedi →',
  },
  EN: {
    about: 'About',
    reviews: 'Reviews',
    login: 'Log in',
    tag: 'Pricing',
    h1: 'One price. No surprises.',
    sub: 'Less than a coffee a day, with nothing more to think about.',
    period: '/month',
    trial: '7 days free · Then €9.99/month · Cancel anytime',
    features: [
      'Unlimited posts for Instagram, Facebook, WhatsApp',
      'Google review replies',
      '3 tones: warm, professional, fun',
      'Copy with one click',
      'Instant access',
    ],
    cta: 'Start free for 7 days →',
    trust: ['🔒 Secure payment', '✓ Cancel anytime', '✓ €0 for 7 days'],
    hasAccount: 'Already have an account?',
    loginLink: 'Log in →',
  },
  ES: {
    about: 'Acerca de',
    reviews: 'Reseñas',
    login: 'Iniciar sesión',
    tag: 'Precios',
    h1: 'Un precio. Sin sorpresas.',
    sub: 'Menos que un café al día, sin más preocupaciones.',
    period: '/mes',
    trial: '7 días gratis · Luego €9,99/mes · Cancela cuando quieras',
    features: [
      'Publicaciones ilimitadas para Instagram, Facebook, WhatsApp',
      'Respuestas a reseñas de Google',
      '3 tonos: cálido, profesional, divertido',
      'Copia con un clic',
      'Acceso inmediato',
    ],
    cta: 'Empieza gratis durante 7 días →',
    trust: ['🔒 Pago seguro', '✓ Cancela cuando quieras', '✓ €0 durante 7 días'],
    hasAccount: '¿Ya tienes una cuenta?',
    loginLink: 'Iniciar sesión →',
  },
  DE: {
    about: 'Über uns',
    reviews: 'Bewertungen',
    login: 'Anmelden',
    tag: 'Preise',
    h1: 'Ein Preis. Keine Überraschungen.',
    sub: 'Weniger als ein Kaffee am Tag, ohne weiteres Nachdenken.',
    period: '/Monat',
    trial: '7 Tage kostenlos · Dann €9,99/Monat · Jederzeit kündbar',
    features: [
      'Unbegrenzte Beiträge für Instagram, Facebook, WhatsApp',
      'Google-Bewertungsantworten',
      '3 Töne: warm, professionell, lustig',
      'Mit einem Klick kopieren',
      'Sofortiger Zugang',
    ],
    cta: 'Kostenlos 7 Tage starten →',
    trust: ['🔒 Sichere Zahlung', '✓ Jederzeit kündbar', '✓ €0 für 7 Tage'],
    hasAccount: 'Haben Sie bereits ein Konto?',
    loginLink: 'Anmelden →',
  },
  FR: {
    about: 'À propos',
    reviews: 'Avis',
    login: 'Se connecter',
    tag: 'Tarifs',
    h1: 'Un prix. Pas de surprises.',
    sub: 'Moins qu\'un café par jour, sans plus y penser.',
    period: '/mois',
    trial: '7 jours gratuits · Puis €9,99/mois · Résiliez quand vous voulez',
    features: [
      'Publications illimitées pour Instagram, Facebook, WhatsApp',
      'Réponses aux avis Google',
      '3 tons : chaleureux, professionnel, fun',
      'Copier en un clic',
      'Accès immédiat',
    ],
    cta: 'Commencer gratuitement pendant 7 jours →',
    trust: ['🔒 Paiement sécurisé', '✓ Résiliez quand vous voulez', '✓ €0 pendant 7 jours'],
    hasAccount: 'Vous avez déjà un compte ?',
    loginLink: 'Se connecter →',
  },
  PL: {
    about: 'O nas',
    reviews: 'Opinie',
    login: 'Zaloguj się',
    tag: 'Cennik',
    h1: 'Jedna cena. Żadnych niespodzianek.',
    sub: 'Mniej niż kawa dziennie i już nie musisz o tym myśleć.',
    period: '/mies.',
    trial: '7 dni za darmo · Potem €9,99/mies. · Anuluj w każdej chwili',
    features: [
      'Nieograniczone posty na Instagram, Facebook, WhatsApp',
      'Odpowiedzi na recenzje Google',
      '3 tony: ciepły, profesjonalny, zabawny',
      'Kopiuj jednym klikiem',
      'Natychmiastowy dostęp',
    ],
    cta: 'Zacznij za darmo przez 7 dni →',
    trust: ['🔒 Bezpieczna płatność', '✓ Anuluj w każdej chwili', '✓ €0 przez 7 dni'],
    hasAccount: 'Masz już konto?',
    loginLink: 'Zaloguj się →',
  },
}

function detectLang() {
  const lang = (navigator.language || '').toLowerCase()
  if (lang.startsWith('pl')) return 'PL'
  if (lang.startsWith('en')) return 'EN'
  if (lang.startsWith('es')) return 'ES'
  if (lang.startsWith('de')) return 'DE'
  if (lang.startsWith('fr')) return 'FR'
  return 'IT'
}

function renderTM(s) {
  if (typeof s !== 'string' || !s.includes('™')) return s
  const i = s.indexOf('™')
  return <>{s.slice(0, i)}<sup style={{fontSize:'0.5em',verticalAlign:'super',lineHeight:0}}>™</sup>{s.slice(i + 1)}</>
}

export default function Pricing() {
  const t = UI_TEXT[detectLang()]

  const handleStart = () => {} // payments disabled

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Lora:wght@600;700&family=DM+Sans:wght@300;400;500;600&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #0A0A0A; }
        .pricing-cta {
          width: 100%; background: #C9922A; color: #0A0A0A;
          padding: 15px; border-radius: 10px; font-size: 16px;
          font-weight: 700; border: none;
          font-family: 'DM Sans', sans-serif; letter-spacing: 0.2px;
          margin-top: 32px;
          cursor: default; opacity: 0.6; pointer-events: none;
        }
      `}</style>

      <div style={{ minHeight: '100vh', background: '#0A0A0A', fontFamily: "'DM Sans', sans-serif", color: '#F0EDE8' }}>

        {/* Navbar */}
        <nav className="site-nav" style={{
          position: 'sticky', top: 0, zIndex: 100,
          background: 'rgba(10,10,10,0.92)', backdropFilter: 'blur(12px)',
          borderBottom: '1px solid #2C2C2C',
          padding: '0 24px', height: 60,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <PostMioLogo size="md" variant="dark" />
          </Link>
          <div className="site-nav-links" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <Link to="/about" style={{ fontSize: 14, color: '#7A7A7A', textDecoration: 'none', fontWeight: 500 }}>
              {t.about}
            </Link>
            <Link to="/reviews" style={{ fontSize: 14, color: '#7A7A7A', textDecoration: 'none', fontWeight: 500 }}>
              {t.reviews}
            </Link>
            <Link to="/login" style={{ fontSize: 14, color: '#7A7A7A', textDecoration: 'none', fontWeight: 500 }}>
              {t.login}
            </Link>
          </div>
        </nav>

        {/* Hero */}
        <section style={{ textAlign: 'center', padding: '72px 24px 40px' }}>
          <div style={{
            display: 'inline-block', background: 'rgba(201,146,42,0.12)', border: '1px solid #C9922A',
            borderRadius: 20, padding: '4px 14px', fontSize: 11, fontWeight: 600,
            color: '#C9922A', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 24,
          }}>{t.tag}</div>
          <h1 style={{ fontFamily: "'Lora', serif", fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 700, color: '#F0EDE8', marginBottom: 16 }}>
            {t.h1}
          </h1>
          <p style={{ fontSize: 17, color: '#7A7A7A', maxWidth: 440, margin: '0 auto' }}>
            {t.sub}
          </p>
        </section>

        {/* Pricing card */}
        <section style={{ padding: '40px 24px 80px', maxWidth: 480, margin: '0 auto' }}>
          <div style={{
            background: '#141414', border: '2px solid #C9922A',
            borderRadius: 20, padding: '40px 32px',
            boxShadow: '0 8px 48px rgba(201,146,42,0.15)',
          }}>
            <div style={{
              display: 'inline-block', background: '#C9922A', color: '#0A0A0A',
              borderRadius: 20, padding: '4px 18px',
              fontSize: 11, fontWeight: 700, letterSpacing: 1.5,
              textTransform: 'uppercase', marginBottom: 24,
            }}>PostMio<sup style={{fontSize:'0.5em',verticalAlign:'super',lineHeight:0}}>™</sup> Pro</div>

            <div style={{ marginBottom: 8 }}>
              <span style={{ fontFamily: "'Lora', serif", fontSize: 56, fontWeight: 700, color: '#F0EDE8' }}>€9,99</span>
              <span style={{ fontSize: 16, color: '#7A7A7A' }}>{t.period}</span>
            </div>
            <p style={{ fontSize: 13, color: '#7A7A7A', marginBottom: 32 }}>
              {t.trial}
            </p>

            {t.features.map(item => (
              <div key={item} style={{
                fontSize: 14, color: '#A0A0A0',
                padding: '9px 0', borderBottom: '1px solid #2C2C2C',
                display: 'flex', alignItems: 'center', gap: 10,
              }}>
                <span style={{ color: '#C9922A', flexShrink: 0 }}>✓</span>
                {item}
              </div>
            ))}

            <button className="pricing-cta" onClick={handleStart} disabled>
              🚀 Coming Soon — Stay tuned for launch!
            </button>

            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center', gap: 20, flexWrap: 'wrap' }}>
              {t.trust.map(item => (
                <span key={item} style={{ fontSize: 11, color: '#555' }}>{item}</span>
              ))}
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: 32 }}>
            <span style={{ fontSize: 14, color: '#7A7A7A' }}>{t.hasAccount} </span>
            <Link to="/login" style={{ fontSize: 14, color: '#C9922A', fontWeight: 600, textDecoration: 'none' }}>{t.loginLink}</Link>
          </div>
          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <Link to="/privacy" style={{ fontSize: 12, color: '#555', textDecoration: 'none' }}>Privacy Policy</Link>
          </div>
        </section>

      </div>
    </>
  )
}
